import CustomHelmet from '../CustomHelmet';
import { Button, Box, Typography, Grid, FormControl } from '@mui/material';
import { Link } from 'react-router-dom';
import { BASE_TITLE } from '../Common';
import SuccessCases from '../ListGroups/SuccessCases';
import { industryOrder, industryMeta } from '../ListGroups/SuccessCaseMeta';
import { groupBy } from '../Common/Functions';
import IndustrySection from './IndustrySection';
import { categoryTabLinkSx, categoryTabTitleSx, categoryTabDescSx, successCaseTypography } from '../designTokens';
import { successCaseSeo } from '../seoMeta';

const Index = () => {
    const grouped = groupBy(SuccessCases, 'industryKind');
    const industries = industryOrder.filter((key) => grouped[key]?.length);

    return (
        <>
            <CustomHelmet
                title={BASE_TITLE + '成功案例'}
                description={successCaseSeo.description}
                keywords={successCaseSeo.keywords}
            />
            <FormControl component="article" fullWidth>
                {/* Quick nav */}
                <Grid container spacing={2} sx={{ mb: { xs: 4, md: 5 } }}>
                    {industries.map((kind, index) => (
                        <Grid item xs={12} sm={6} md={3} key={kind}>
                            <Box
                                component="a"
                                href={`#${industryMeta[kind]?.id}`}
                                sx={categoryTabLinkSx}
                            >
                                <Typography className="category-tab-title" sx={categoryTabTitleSx}>
                                    {index + 1}. {industryMeta[kind]?.tag || kind}
                                </Typography>
                                <Typography variant="body2" className="category-tab-desc" sx={categoryTabDescSx}>
                                    {kind}（{grouped[kind].length} 案）
                                </Typography>
                            </Box>
                        </Grid>
                    ))}
                </Grid>

                {/* Industry sections */}
                {industries.map((kind, index) => (
                    <IndustrySection
                        key={kind}
                        industryKind={kind}
                        caseList={grouped[kind]}
                        index={index}
                        reverse={index % 2 === 1}
                    />
                ))}

                {/* CTA */}
                <Box
                    sx={{
                        mt: 2,
                        p: { xs: 3, md: 4 },
                        textAlign: 'center',
                        borderRadius: '12px',
                        backgroundColor: '#F5FCFC',
                        border: '1px solid #DAEDED',
                    }}
                >
                    <Typography sx={{ ...successCaseTypography.blockLabel, fontWeight: 700, color: '#03363D', mb: 1 }}>
                        想為您的企業打造專屬系統？
                    </Typography>
                    <Typography sx={{ ...successCaseTypography.body, color: 'text.secondary', mb: 3, maxWidth: 640, mx: 'auto' }}>
                        歡迎與我們聯繫，分享您的需求，由顧問為您評估合適的開發方案。
                        若您正規劃{' '}
                        <Box component={Link} to="/ProductIntro" sx={{ color: 'primary.main', fontWeight: 600 }}>
                            AI 應用系統服務
                        </Box>
                        或{' '}
                        <Box component={Link} to="/ai-inventory" sx={{ color: 'primary.main', fontWeight: 600 }}>
                            AI 進銷存管理系統
                        </Box>
                        ，亦可一併於表單中勾選相關項目，我們將依產業與流程提供建議。
                    </Typography>
                    <Button
                        component={Link}
                        to="/contactus"
                        state={{ anchor: 'default' }}
                        size="large"
                        variant="contained"
                        color="primary"
                        sx={{ fontSize: '16px', px: 4 }}
                    >
                        聯絡我們
                    </Button>
                </Box>
            </FormControl>
        </>
    );
};

export default Index;
